/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RepliedInputs */

const cs_enum_replied = /** @type {(inputs: Enum_RepliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpovězeno`)
};

const en_enum_replied = /** @type {(inputs: Enum_RepliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replied`)
};

/**
* | output |
* | --- |
* | "Replied" |
*
* @param {Enum_RepliedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_replied = /** @type {((inputs?: Enum_RepliedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RepliedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_replied(inputs)
	return cs_enum_replied(inputs)
});